import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[3]};
`;

export const SectionTitle = styled.h3`
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black};
    margin: 0;
    margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[3]};
`;

export const AmountInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[1]};
    max-width: 200px;
`;

export const WarningMessage = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[2]};
    background-color: ${({ theme }) => theme.color.io.warning100};
    border: 1px solid ${({ theme }) => theme.color.yellow200};
    border-radius: ${({ theme }) => theme.radius.main};
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.io.warning500};
`;

export const Description = styled.p`
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.grey400};
    margin: 0;
`;
